import React, { useState, useEffect } from "react";
import { ThemeProvider } from "styled-components";
import ReactDOM from "react-dom/client";
import styled from "styled-components";
import theme from "~/styles/theme";
import Button from "~/shared/Btn";

const Container = styled.div`
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 100;

    .content {
        background-color: white;
        width: 80%;
        max-width: 500px;
        height: auto;
        margin: 0 auto;
        border-radius: 16px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        overflow: hidden;
        box-shadow: 0px 14px 14px rgba(27, 27, 28, 0.11);
        padding: 1.5rem;
        transition: transform 0.3s;

        .actions {
            margin-top: 2rem;
            text-align: right;
        }
    }

    .content.mounted {
        transform: translate(-50%, -50%) scale(1);
    }
`;

const Dialog = (props) => {
    window.scrollTo(0, 0);

    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setMounted(true);
        }, 1);
    }, []);

    return (
        <Container>
            <div className={`content ${mounted ? "mounted" : ""}`}>
                <div className="body">{props.message}</div>
                <div className="actions">
                    <Button
                        variant="secondary"
                        onClick={() => {
                            props.actionFunction && props.actionFunction();
                            props.close();
                        }}
                    >
                        {props.actionText}
                    </Button>
                </div>
            </div>
        </Container>
    );
};

const renderDialog = (message, actionText, actionFunction) => {
    const confirmRoot = document.createElement("div");
    const body = document.querySelector("body");
    body.appendChild(confirmRoot);

    const root = ReactDOM.createRoot(confirmRoot);

    const close = () => {
        root.unmount();
    };

    root.render(
        <ThemeProvider theme={theme}>
            <Dialog close={close} message={message} actionText={actionText} actionFunction={actionFunction} />
        </ThemeProvider>
    );
};

export default renderDialog;
